import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';

const SaludFinancieraPage: React.FC = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();

    const t = (es: string, en: string) => language === 'es' ? es : en;

    const handleThemeChange = (theme: number) => {
        const bookRoutes = {
            2: '/libros/1',
            3: '/libros/2', 
            4: '/libros/3',
            5: '/libros/4',
            6: '/libros/5',
            7: '/libros/6',
            8: '/libros/7',
            9: '/libros/8'
        };
        const route = bookRoutes[theme as keyof typeof bookRoutes];
        if (route) {
            window.location.href = route;
        }
    };

    return (
        <div className="min-h-screen">
            {/* Navbar */}
            <Navbar currentTheme={1} onThemeChange={handleThemeChange} />
            
            {/* Contenido principal */}
            <main className="pt-16">
                {/* Sección principal con imagen de fondo */}
                <section className="relative min-h-screen">
                    {/* Imagen de fondo */}
                    <div 
                        className="absolute inset-0 w-full h-full"
                        style={{
                            backgroundImage: 'url(/images/infosection/saludfinanciera.png)',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat'
                        }}
                    >
                        {/* Overlay sutil para mejorar legibilidad */}
                        <div className="absolute inset-0 bg-black/10"></div>
                    </div>

                    {/* Contenido a la izquierda */}
                    <div className="relative z-10 min-h-screen flex items-center justify-start">
                        <div className="w-full lg:w-1/2 p-8 lg:p-12">
                            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 lg:p-12 shadow-2xl">
                                <div className="space-y-8">
                                    <div className="text-center lg:text-left">
                                        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-r from-purple-500 to-pink-600 text-white text-3xl mb-6">
                                            💰
                                        </div>
                                        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-4">
                                            {t('Salud Financiera', 'Financial Health')}
                                        </h1>
                                        <p className="text-lg text-gray-700 leading-relaxed">
                                            {t(
                                                'Impulsa tu libertad: aprende a obtener y gestionar los recursos necesarios para financiar y hacer realidad tus proyectos. Haz tus sueños realidad con plena autonomía.',
                                                'Boost your freedom: learn to obtain and manage the necessary resources to finance and make your projects a reality. Make your dreams come true with full autonomy.'
                                            )}
                                        </p>
                                    </div>

                                    {/* Botones de navegación */}
                                    <div className="flex flex-col sm:flex-row gap-4 pt-8">
                                        <button 
                                            onClick={() => navigate('/curriculum-holistico')}
                                            className="px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-full font-bold hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                                        >
                                            {t('Volver al Currículum', 'Back to Curriculum')}
                                        </button>
                                        <button 
                                            onClick={() => navigate('/')}
                                            className="px-8 py-4 border-2 border-gray-300 text-gray-700 rounded-full font-bold hover:bg-gray-50 transition-all duration-300 transform hover:scale-105"
                                        >
                                            {t('Volver al Inicio', 'Back to Home')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default SaludFinancieraPage; 